/* eslint-disable import/prefer-default-export */
import { useMemo } from 'react'

import { getOrganizationAssetTypeOptions } from '../utils'

import { useOrganizationGtmQuery } from '~generated/hooks'

export function useOrganizationAssetTypeOptions() {
  const { data: { organization } = {} } = useOrganizationGtmQuery({
    fetchPolicy: 'cache-first',
  })

  return useMemo(() => {
    return getOrganizationAssetTypeOptions(organization?.haveGtm)
  }, [organization?.haveGtm])
}
